// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;500;600&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* --- Fonts and Base Styles --- */

:root,
[data-theme="light"] {
    --background-light: #F7F9F8;
    --header-bg: #FFFFFF;
    --bot-bubble-bg: #FFFFFF;
    --user-bubble-bg: #1FBF8F;
    --text-primary: #040f25;
    --text-secondary: #6B7280;
    --border-color: #EBEBEB;
    --input-bg: #FFFFFF;
    --accent-blue: #1FBF8F;
    --accent-blue-hover: #1AA7B8;
    --tab-inactive-bg: #E6ECEA;
    --shadow-sm: 0 1px 3px rgba(0, 0, 0, 0.05);
    --shadow-md: 0 4px 6px rgba(0, 0, 0, 0.1);
}

[data-theme="dark"] {
    --background-light: #000000;
    --header-bg: #000000;
    --bot-bubble-bg: #1a1a1a;
    --user-bubble-bg: #1FBF8F;
    --text-primary: #F7F9F8;
    --text-secondary: #adb5bd;
    --border-color: #1a1a1a;
    --input-bg: #1a1a1a;
    --accent-blue: #1FBF8F;
    --accent-blue-hover: #1AA7B8;
    --tab-inactive-bg: #1a1a1a;
    --shadow-sm: 0 1px 3px rgba(0, 0, 0, 0.3);
    --shadow-md: 0 4px 6px rgba(0, 0, 0, 0.4);
}

* {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
}

body {
    font-family: 'Open Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
    background-color: var(--background-light);
    color: var(--text-primary);
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-size: 16px;
}

/* --- Main App Layout --- */
.app-container {
    display: flex;
    flex-direction: column;
    height: 100vh;
    width: 100%;
    max-width: 800px;
    margin: 0 auto;
    background-color: var(--background-light);
}

.app-header {
    padding: 1rem;
    background-color: var(--background-light);
    display: flex;
    align-items: center;
    justify-content: center;
}

.tabs {
    display: flex;
    background-color: var(--tab-inactive-bg);
    border-radius: 12px;
    padding: 4px;
    width: calc(100% - 3rem);
    max-width: 400px;
}

.tab {
    flex: 1 1;
    padding: 0.75rem 1rem;
    border: none;
    border-radius: 10px;
    background-color: transparent;
    color: var(--text-secondary);
    font-family: 'Open Sans', sans-serif;
    font-size: 0.9rem;
    font-weight: 600;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    transition: all 0.3s ease;
}

.tab.active {
    background-color: var(--header-bg);
    color: var(--accent-blue);
    box-shadow: var(--shadow-md), 0 0 0 2px var(--accent-blue);
}

.tab.active svg {
    fill: var(--accent-blue);
}

.tab svg {
    fill: var(--text-secondary);
}

.chat-window {
    flex: 1 1;
    overflow-y: auto;
    padding: 1rem;
    display: flex;
    flex-direction: column;
    gap: 1rem;
    background-color: var(--background-light);
}

/* --- Message Bubbles & Avatars --- */
.message-container {
    display: flex;
    gap: 0.5rem;
    max-width: 85%;
}

.message-container.user {
    align-self: flex-end;
    flex-direction: row-reverse;
}

.message-container.bot {
    align-self: flex-start;
}

.avatar {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 500;
    font-size: 0.9rem;
    flex-shrink: 0;
    box-shadow: var(--shadow-sm);
    border: 2px solid var(--accent-blue);
}

.bot-avatar, .user-avatar {
    background: transparent;
}

.bot-avatar svg, .user-avatar svg {
    width: 36px;
    height: 36px;
}

.message-bubble {
    padding: 0.9rem 1rem;
    border-radius: 1.2rem;
    word-wrap: break-word;
    line-height: 1.6;
    font-size: 1.05rem;
    animation: pop-in 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
    box-shadow: var(--shadow-md);
}

@keyframes pop-in {
    from { transform: scale(0.95); opacity: 0; }
    to { transform: scale(1); opacity: 1; }
}

.message-bubble.user {
    background: var(--user-bubble-bg);
    color: white;
    border-top-right-radius: 0.5rem;
}

.message-bubble.bot {
    background-color: var(--bot-bubble-bg);
    color: var(--text-primary);
    border-top-left-radius: 0.5rem;
    box-shadow: 0 4px 12px rgba(0,0,0,0.05);
}

.message-bubble p, .message-bubble ul, .message-bubble ol {
    margin: 0.5rem 0;
}
.message-bubble ul, .message-bubble ol {
    padding-left: 1.25rem;
}

/* --- Typing Indicator --- */
.typing-indicator {
    display: flex;
    align-items: center;
    gap: 5px;
    padding: 10px 0;
}
.typing-indicator span {
    height: 8px;
    width: 8px;
    background-color: var(--text-secondary);
    border-radius: 50%;
    animation: bounce 1.4s infinite ease-in-out both;
}
.typing-indicator span:nth-child(1) { animation-delay: -0.32s; }
.typing-indicator span:nth-child(2) { animation-delay: -0.16s; }
@keyframes bounce {
    0%, 80%, 100% { transform: scale(0); }
    40% { transform: scale(1.0); }
}

/* --- Footer & Input --- */
.app-footer {
    padding: 1rem 1.5rem;
    background-color: var(--background-light);
}

.message-form {
    display: flex;
    align-items: center;
    background-color: var(--input-bg);
    border: 2px solid var(--border-color);
    border-radius: 1.5rem;
    padding: 0.5rem 0.75rem;
    box-shadow: var(--shadow-md);
    transition: box-shadow 0.3s ease, border-color 0.3s ease;
}

.message-form:focus-within {
    border-color: var(--accent-blue);
    box-shadow: var(--shadow-md);
}

.message-form input {
    flex: 1 1;
    background-color: transparent;
    border: none;
    color: var(--text-primary);
    font-size: 1rem;
    font-family: 'Open Sans', sans-serif;
}
.message-form input:focus { outline: none; }
.message-form input::placeholder { color: var(--text-secondary); }

.message-form button {
    background: transparent;
    border: none;
    cursor: pointer;
    padding: 0.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
}
.message-form button img {
    width: 24px;
    height: 24px;
    opacity: 0.8;
    transition: opacity 0.2s;
}
.message-form button:hover img {
    opacity: 1;
}
.message-form button:disabled {
    cursor: not-allowed;
    opacity: 0.5;
}
.message-form button.send-button {
    background-color: var(--accent-blue);
    border-radius: 1rem;
    transition: background-color 0.2s ease;
    padding: 0.75rem;
}
.message-form button.send-button:hover:not(:disabled) {
    background-color: var(--accent-blue-hover);
}
.message-form button.send-button:disabled {
    background-color: #D1D5DB;
    opacity: 1;
}

.spinner {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    border: 2px solid rgba(255, 255, 255, 0.3);
    border-top-color: #ffffff;
    animation: spin 1s linear infinite;
}
@keyframes spin { to { transform: rotate(360deg); } }

/* --- Quick Replies --- */
.quick-actions-section {
    padding: 0 1.5rem 0.5rem;
}
.quick-actions-section h2 {
    font-size: 0.9rem;
    font-weight: 600;
    margin-bottom: 0.5rem;
}
.quick-replies-container {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 0.4rem;
}

.quick-reply-button {
    background-color: var(--bot-bubble-bg);
    color: var(--text-primary);
    border: 2px solid var(--border-color);
    padding: 0.4rem;
    border-radius: 10px;
    font-size: 0.7rem;
    font-family: 'Open Sans', sans-serif;
    cursor: pointer;
    transition: background-color 0.2s, box-shadow 0.2s, border-color 0.2s;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 0.2rem;
    box-shadow: 0 2px 6px rgba(0,0,0,0.04);
}
.quick-reply-button svg {
    width: 20px;
    height: 20px;
}
.quick-reply-button:hover {
    background-color: #f9f9f9;
    box-shadow: 0 4px 10px rgba(0,0,0,0.07);
}

.quick-reply-button:focus {
    outline: none;
    border-color: var(--accent-blue);
    box-shadow: var(--shadow-md);
}
.quick-reply-button span {
    font-weight: 600;
}

/* --- Voice Mode Overlay --- */
.voice-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: var(--background-light);
    z-index: 1000;
    display: flex;
    flex-direction: column;
}

.voice-overlay-header {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: 1rem 1.5rem;
    border-bottom: 2px solid var(--border-color);
    background-color: var(--header-bg);
}

.voice-overlay-close-button {
    background: transparent;
    border: none;
    cursor: pointer;
}
.voice-overlay-close-button img {
    width: 24px;
    height: 24px;
}

.voice-overlay-content {
    flex-grow: 1;
    overflow: hidden;
}

/* --- Tooltip (kept from previous design) --- */
.voice-button-container {
    position: relative;
}
.voice-tooltip {
    position: absolute;
    bottom: 120%;
    left: 50%;
    transform: translateX(-50%);
    background-color: var(--bot-bubble-bg);
    color: var(--text-primary);
    padding: 6px 12px;
    border-radius: 8px;
    font-size: 0.8rem;
    white-space: nowrap;
    z-index: 10;
}
.voice-tooltip::after {
    content: '';
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    border-width: 5px;
    border-style: solid;
    border-color: var(--bot-bubble-bg) transparent transparent transparent;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,kCAAkC;;AAGlC;;IAEI,2BAA2B;IAC3B,oBAAoB;IACpB,wBAAwB;IACxB,yBAAyB;IACzB,uBAAuB;IACvB,yBAAyB;IACzB,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;IACtB,4BAA4B;IAC5B,0BAA0B;IAC1B,0CAA0C;IAC1C,yCAAyC;AAC7C;;AAEA;IACI,2BAA2B;IAC3B,oBAAoB;IACpB,wBAAwB;IACxB,yBAAyB;IACzB,uBAAuB;IACvB,yBAAyB;IACzB,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;IACtB,4BAA4B;IAC5B,0BAA0B;IAC1B,yCAAyC;IACzC,yCAAyC;AAC7C;;AAEA;IACI,sBAAsB;IACtB,SAAS;IACT,UAAU;AACd;;AAEA;IACI,qJAAqJ;IACrJ,yCAAyC;IACzC,0BAA0B;IAC1B,mCAAmC;IACnC,kCAAkC;IAClC,eAAe;AACnB;;AAEA,4BAA4B;AAC5B;IACI,aAAa;IACb,sBAAsB;IACtB,aAAa;IACb,WAAW;IACX,gBAAgB;IAChB,cAAc;IACd,yCAAyC;AAC7C;;AAEA;IACI,aAAa;IACb,yCAAyC;IACzC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,wCAAwC;IACxC,mBAAmB;IACnB,YAAY;IACZ,wBAAwB;IACxB,gBAAgB;AACpB;;AAEA;IACI,SAAO;IACP,qBAAqB;IACrB,YAAY;IACZ,mBAAmB;IACnB,6BAA6B;IAC7B,4BAA4B;IAC5B,oCAAoC;IACpC,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,kCAAkC;IAClC,yBAAyB;IACzB,0DAA0D;AAC9D;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,SAAO;IACP,gBAAgB;IAChB,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,yCAAyC;AAC7C;;AAEA,sCAAsC;AACtC;IACI,aAAa;IACb,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,oBAAoB;IACpB,2BAA2B;AAC/B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;IACd,4BAA4B;IAC5B,oCAAoC;AACxC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,oBAAoB;IACpB,qBAAqB;IACrB,qBAAqB;IACrB,gBAAgB;IAChB,kBAAkB;IAClB,8DAA8D;IAC9D,4BAA4B;AAChC;;AAEA;IACI,OAAO,sBAAsB,EAAE,UAAU,EAAE;IAC3C,KAAK,mBAAmB,EAAE,UAAU,EAAE;AAC1C;;AAEA;IACI,iCAAiC;IACjC,YAAY;IACZ,+BAA+B;AACnC;;AAEA;IACI,sCAAsC;IACtC,0BAA0B;IAC1B,8BAA8B;IAC9B,uCAAuC;AAC3C;;AAEA;IACI,gBAAgB;AACpB;AACA;IACI,qBAAqB;AACzB;;AAEA,6BAA6B;AAC7B;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;AACnB;AACA;IACI,WAAW;IACX,UAAU;IACV,uCAAuC;IACvC,kBAAkB;IAClB,gDAAgD;AACpD;AACA,sCAAsC,uBAAuB,EAAE;AAC/D,sCAAsC,uBAAuB,EAAE;AAC/D;IACI,gBAAgB,mBAAmB,EAAE;IACrC,MAAM,qBAAqB,EAAE;AACjC;;AAEA,2BAA2B;AAC3B;IACI,oBAAoB;IACpB,yCAAyC;AAC7C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,iCAAiC;IACjC,qCAAqC;IACrC,qBAAqB;IACrB,uBAAuB;IACvB,4BAA4B;IAC5B,wDAAwD;AAC5D;;AAEA;IACI,gCAAgC;IAChC,4BAA4B;AAChC;;AAEA;IACI,SAAO;IACP,6BAA6B;IAC7B,YAAY;IACZ,0BAA0B;IAC1B,eAAe;IACf,oCAAoC;AACxC;AACA,4BAA4B,aAAa,EAAE;AAC3C,mCAAmC,4BAA4B,EAAE;;AAEjE;IACI,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,wBAAwB;AAC5B;AACA;IACI,UAAU;AACd;AACA;IACI,mBAAmB;IACnB,YAAY;AAChB;AACA;IACI,oCAAoC;IACpC,mBAAmB;IACnB,sCAAsC;IACtC,gBAAgB;AACpB;AACA;IACI,0CAA0C;AAC9C;AACA;IACI,yBAAyB;IACzB,UAAU;AACd;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,0CAA0C;IAC1C,yBAAyB;IACzB,kCAAkC;AACtC;AACA,kBAAkB,KAAK,yBAAyB,EAAE,EAAE;;AAEpD,0BAA0B;AAC1B;IACI,wBAAwB;AAC5B;AACA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,qBAAqB;AACzB;AACA;IACI,aAAa;IACb,qCAAqC;IACrC,WAAW;AACf;;AAEA;IACI,sCAAsC;IACtC,0BAA0B;IAC1B,qCAAqC;IACrC,eAAe;IACf,mBAAmB;IACnB,iBAAiB;IACjB,oCAAoC;IACpC,eAAe;IACf,qEAAqE;IACrE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,sCAAsC;AAC1C;AACA;IACI,WAAW;IACX,YAAY;AAChB;AACA;IACI,yBAAyB;IACzB,uCAAuC;AAC3C;;AAEA;IACI,aAAa;IACb,gCAAgC;IAChC,4BAA4B;AAChC;AACA;IACI,gBAAgB;AACpB;;AAEA,+BAA+B;AAC/B;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,yCAAyC;IACzC,aAAa;IACb,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,oBAAoB;IACpB,4CAA4C;IAC5C,kCAAkC;AACtC;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,eAAe;AACnB;AACA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,gBAAgB;AACpB;;AAEA,gDAAgD;AAChD;IACI,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,YAAY;IACZ,SAAS;IACT,2BAA2B;IAC3B,sCAAsC;IACtC,0BAA0B;IAC1B,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;IACnB,WAAW;AACf;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,2BAA2B;IAC3B,iBAAiB;IACjB,mBAAmB;IACnB,sEAAsE;AAC1E","sourcesContent":["/* --- Fonts and Base Styles --- */\n@import url('https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;500;600&display=swap');\n\n:root,\n[data-theme=\"light\"] {\n    --background-light: #F7F9F8;\n    --header-bg: #FFFFFF;\n    --bot-bubble-bg: #FFFFFF;\n    --user-bubble-bg: #1FBF8F;\n    --text-primary: #040f25;\n    --text-secondary: #6B7280;\n    --border-color: #EBEBEB;\n    --input-bg: #FFFFFF;\n    --accent-blue: #1FBF8F;\n    --accent-blue-hover: #1AA7B8;\n    --tab-inactive-bg: #E6ECEA;\n    --shadow-sm: 0 1px 3px rgba(0, 0, 0, 0.05);\n    --shadow-md: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n[data-theme=\"dark\"] {\n    --background-light: #000000;\n    --header-bg: #000000;\n    --bot-bubble-bg: #1a1a1a;\n    --user-bubble-bg: #1FBF8F;\n    --text-primary: #F7F9F8;\n    --text-secondary: #adb5bd;\n    --border-color: #1a1a1a;\n    --input-bg: #1a1a1a;\n    --accent-blue: #1FBF8F;\n    --accent-blue-hover: #1AA7B8;\n    --tab-inactive-bg: #1a1a1a;\n    --shadow-sm: 0 1px 3px rgba(0, 0, 0, 0.3);\n    --shadow-md: 0 4px 6px rgba(0, 0, 0, 0.4);\n}\n\n* {\n    box-sizing: border-box;\n    margin: 0;\n    padding: 0;\n}\n\nbody {\n    font-family: 'Open Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;\n    background-color: var(--background-light);\n    color: var(--text-primary);\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    font-size: 16px;\n}\n\n/* --- Main App Layout --- */\n.app-container {\n    display: flex;\n    flex-direction: column;\n    height: 100vh;\n    width: 100%;\n    max-width: 800px;\n    margin: 0 auto;\n    background-color: var(--background-light);\n}\n\n.app-header {\n    padding: 1rem;\n    background-color: var(--background-light);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.tabs {\n    display: flex;\n    background-color: var(--tab-inactive-bg);\n    border-radius: 12px;\n    padding: 4px;\n    width: calc(100% - 3rem);\n    max-width: 400px;\n}\n\n.tab {\n    flex: 1;\n    padding: 0.75rem 1rem;\n    border: none;\n    border-radius: 10px;\n    background-color: transparent;\n    color: var(--text-secondary);\n    font-family: 'Open Sans', sans-serif;\n    font-size: 0.9rem;\n    font-weight: 600;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 0.5rem;\n    transition: all 0.3s ease;\n}\n\n.tab.active {\n    background-color: var(--header-bg);\n    color: var(--accent-blue);\n    box-shadow: var(--shadow-md), 0 0 0 2px var(--accent-blue);\n}\n\n.tab.active svg {\n    fill: var(--accent-blue);\n}\n\n.tab svg {\n    fill: var(--text-secondary);\n}\n\n.chat-window {\n    flex: 1;\n    overflow-y: auto;\n    padding: 1rem;\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n    background-color: var(--background-light);\n}\n\n/* --- Message Bubbles & Avatars --- */\n.message-container {\n    display: flex;\n    gap: 0.5rem;\n    max-width: 85%;\n}\n\n.message-container.user {\n    align-self: flex-end;\n    flex-direction: row-reverse;\n}\n\n.message-container.bot {\n    align-self: flex-start;\n}\n\n.avatar {\n    width: 40px;\n    height: 40px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-weight: 500;\n    font-size: 0.9rem;\n    flex-shrink: 0;\n    box-shadow: var(--shadow-sm);\n    border: 2px solid var(--accent-blue);\n}\n\n.bot-avatar, .user-avatar {\n    background: transparent;\n}\n\n.bot-avatar svg, .user-avatar svg {\n    width: 36px;\n    height: 36px;\n}\n\n.message-bubble {\n    padding: 0.9rem 1rem;\n    border-radius: 1.2rem;\n    word-wrap: break-word;\n    line-height: 1.6;\n    font-size: 1.05rem;\n    animation: pop-in 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);\n    box-shadow: var(--shadow-md);\n}\n\n@keyframes pop-in {\n    from { transform: scale(0.95); opacity: 0; }\n    to { transform: scale(1); opacity: 1; }\n}\n\n.message-bubble.user {\n    background: var(--user-bubble-bg);\n    color: white;\n    border-top-right-radius: 0.5rem;\n}\n\n.message-bubble.bot {\n    background-color: var(--bot-bubble-bg);\n    color: var(--text-primary);\n    border-top-left-radius: 0.5rem;\n    box-shadow: 0 4px 12px rgba(0,0,0,0.05);\n}\n\n.message-bubble p, .message-bubble ul, .message-bubble ol {\n    margin: 0.5rem 0;\n}\n.message-bubble ul, .message-bubble ol {\n    padding-left: 1.25rem;\n}\n\n/* --- Typing Indicator --- */\n.typing-indicator {\n    display: flex;\n    align-items: center;\n    gap: 5px;\n    padding: 10px 0;\n}\n.typing-indicator span {\n    height: 8px;\n    width: 8px;\n    background-color: var(--text-secondary);\n    border-radius: 50%;\n    animation: bounce 1.4s infinite ease-in-out both;\n}\n.typing-indicator span:nth-child(1) { animation-delay: -0.32s; }\n.typing-indicator span:nth-child(2) { animation-delay: -0.16s; }\n@keyframes bounce {\n    0%, 80%, 100% { transform: scale(0); }\n    40% { transform: scale(1.0); }\n}\n\n/* --- Footer & Input --- */\n.app-footer {\n    padding: 1rem 1.5rem;\n    background-color: var(--background-light);\n}\n\n.message-form {\n    display: flex;\n    align-items: center;\n    background-color: var(--input-bg);\n    border: 2px solid var(--border-color);\n    border-radius: 1.5rem;\n    padding: 0.5rem 0.75rem;\n    box-shadow: var(--shadow-md);\n    transition: box-shadow 0.3s ease, border-color 0.3s ease;\n}\n\n.message-form:focus-within {\n    border-color: var(--accent-blue);\n    box-shadow: var(--shadow-md);\n}\n\n.message-form input {\n    flex: 1;\n    background-color: transparent;\n    border: none;\n    color: var(--text-primary);\n    font-size: 1rem;\n    font-family: 'Open Sans', sans-serif;\n}\n.message-form input:focus { outline: none; }\n.message-form input::placeholder { color: var(--text-secondary); }\n\n.message-form button {\n    background: transparent;\n    border: none;\n    cursor: pointer;\n    padding: 0.5rem;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n.message-form button img {\n    width: 24px;\n    height: 24px;\n    opacity: 0.8;\n    transition: opacity 0.2s;\n}\n.message-form button:hover img {\n    opacity: 1;\n}\n.message-form button:disabled {\n    cursor: not-allowed;\n    opacity: 0.5;\n}\n.message-form button.send-button {\n    background-color: var(--accent-blue);\n    border-radius: 1rem;\n    transition: background-color 0.2s ease;\n    padding: 0.75rem;\n}\n.message-form button.send-button:hover:not(:disabled) {\n    background-color: var(--accent-blue-hover);\n}\n.message-form button.send-button:disabled {\n    background-color: #D1D5DB;\n    opacity: 1;\n}\n\n.spinner {\n    width: 20px;\n    height: 20px;\n    border-radius: 50%;\n    border: 2px solid rgba(255, 255, 255, 0.3);\n    border-top-color: #ffffff;\n    animation: spin 1s linear infinite;\n}\n@keyframes spin { to { transform: rotate(360deg); } }\n\n/* --- Quick Replies --- */\n.quick-actions-section {\n    padding: 0 1.5rem 0.5rem;\n}\n.quick-actions-section h2 {\n    font-size: 0.9rem;\n    font-weight: 600;\n    margin-bottom: 0.5rem;\n}\n.quick-replies-container {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 0.4rem;\n}\n\n.quick-reply-button {\n    background-color: var(--bot-bubble-bg);\n    color: var(--text-primary);\n    border: 2px solid var(--border-color);\n    padding: 0.4rem;\n    border-radius: 10px;\n    font-size: 0.7rem;\n    font-family: 'Open Sans', sans-serif;\n    cursor: pointer;\n    transition: background-color 0.2s, box-shadow 0.2s, border-color 0.2s;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 0.2rem;\n    box-shadow: 0 2px 6px rgba(0,0,0,0.04);\n}\n.quick-reply-button svg {\n    width: 20px;\n    height: 20px;\n}\n.quick-reply-button:hover {\n    background-color: #f9f9f9;\n    box-shadow: 0 4px 10px rgba(0,0,0,0.07);\n}\n\n.quick-reply-button:focus {\n    outline: none;\n    border-color: var(--accent-blue);\n    box-shadow: var(--shadow-md);\n}\n.quick-reply-button span {\n    font-weight: 600;\n}\n\n/* --- Voice Mode Overlay --- */\n.voice-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: var(--background-light);\n    z-index: 1000;\n    display: flex;\n    flex-direction: column;\n}\n\n.voice-overlay-header {\n    display: flex;\n    justify-content: flex-end;\n    align-items: center;\n    padding: 1rem 1.5rem;\n    border-bottom: 2px solid var(--border-color);\n    background-color: var(--header-bg);\n}\n\n.voice-overlay-close-button {\n    background: transparent;\n    border: none;\n    cursor: pointer;\n}\n.voice-overlay-close-button img {\n    width: 24px;\n    height: 24px;\n}\n\n.voice-overlay-content {\n    flex-grow: 1;\n    overflow: hidden;\n}\n\n/* --- Tooltip (kept from previous design) --- */\n.voice-button-container {\n    position: relative;\n}\n.voice-tooltip {\n    position: absolute;\n    bottom: 120%;\n    left: 50%;\n    transform: translateX(-50%);\n    background-color: var(--bot-bubble-bg);\n    color: var(--text-primary);\n    padding: 6px 12px;\n    border-radius: 8px;\n    font-size: 0.8rem;\n    white-space: nowrap;\n    z-index: 10;\n}\n.voice-tooltip::after {\n    content: '';\n    position: absolute;\n    top: 100%;\n    left: 50%;\n    transform: translateX(-50%);\n    border-width: 5px;\n    border-style: solid;\n    border-color: var(--bot-bubble-bg) transparent transparent transparent;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
